import { LabClient, LabKitClient, QueriesClient, RoleClient, SampleClient, PersonSearchClient, TranslationClient, UserClient, ProfilesClient, PersonClient, AccountClient, KitClient, WorkQueueClient, RunTypeClient, CaseRunClient } from "./api";

export const userClient = new UserClient();
export const labClient = new LabClient();
export const roleClient = new RoleClient();
export const translationClient = new TranslationClient();
export const sampleClient = new SampleClient();
export const searchClient = new PersonSearchClient();
export const labKitClient = new LabKitClient(); 
export const queriesClient = new QueriesClient();
export const profilesClient = new ProfilesClient();
export const personClient = new PersonClient();
export const accountClient = new AccountClient();
export const kitClient = new KitClient();
export const workQueueClient = new WorkQueueClient();
export const runTypeClient = new RunTypeClient();
export const caseRunClient = new CaseRunClient();
